<template>
  <main class="main">
    <portal to="headerTitle">
      {{ $t('admin.pageSeasonCalendar.title') }} ({{ $route.params.ratePlanType === 'DayRate' ? $t('admin.pageSeasonCalendar.titleRatePlan') : $t('admin.pageSeasonCalendar.titlePackage') }})
    </portal>
    <card :title="$t('admin.pageSeasonCalendar.card.seasonCalendar')" cols="12">
      <hm-card-inner :full-size="true" class="card__inner--sticky">
        <div style="padding: 1.5rem;" class="col-12">
          <template v-if="selection.endDate == null">
            <p class="explanation-text">{{ $t('admin.pageSeasonCalendar.hintStep1') }}</p>
          </template>
          <template v-else>
            <p class="explanation-text">{{ $t('admin.pageSeasonCalendar.hintStep2') }}</p>
          </template>
          <hm-col :grid="false">
            <hm-button :disabled="selection.endDate === null" class="btn--gray btn--inline--width-auto btn--season" cols="1" @click="updateSeason('00000000-00000-0000-0000-0000000000000')">{{ $t('admin.pageSeasonCalendar.removeSeason' ) }}</hm-button>
            <template v-for="season in hotelSettings.seasons.all()">
              <hm-button v-if="season.ratePlanType === $route.params.ratePlanType && season.deleted !== true"
                         :key="season.id"
                         :disabled="selection.endDate === null"
                         :style="`--button-color: ${toRGB(season.rgbColorCode)}`"
                         class="btn--color btn--inline--width-auto btn--season"
                         cols="1"
                         @click="updateSeason(season.id)">{{ season.name[$shortLocale] }}</hm-button>
            </template>
          </hm-col>
        </div>
      </hm-card-inner>
      <hm-card-inner style="z-index: 0;">
        <hm-col cols="12">
          <season-calendar ref="calendar"
                           :months="7"
                           :day-border="true"
                           :months-margin="35"
                           :max-months="40"
                           :date-colors="dateColors"
                           :season-dates="seasonDates"
                           :locale="$shortLocale"
                           available-color="#f5f6f6"
                           @select="selection = $event"
                           @clear="selection = $event" />
        </hm-col>
      </hm-card-inner>
    </card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy, keyBy } from 'lodash';
import fecha from 'fecha';

export default {
  name: 'PageSeasonCalendar',

  components: {
    vueDropzone: vue2Dropzone,
    draggable,
  },

  mixins: [HotelmeisterMixin],

  data() {
    return {
      dateColors: {
      },
      seasonDates: {
      },
      selection: {
        startDate: null,
        endDate: null,
        hoverDate: null,
      },
      minDate: null,
      maxDate: null,
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
    this.minDate = this.$moment().add(-1, 'days').format('YYYY-MM-DD');
    this.maxDate = this.$moment().add(this.hotelSettings.details.futureDates, 'days').format('YYYY-MM-DD');
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    updateSeason(seasonId) {
      this.$store.commit('save/started', this._uid);

      const startDate = this.toISODate(this.selection.startDate);
      const endDate = this.toISODate(this.selection.endDate);

      this.axios.patch(
        this.serviceUrls.seasonDate.list(
          this,
          startDate,
          endDate,
        ),
        {
          [this.$route.params.ratePlanType === 'DayRate' ? 'season' : 'packageSeason']: seasonId,
        },
      ).then((response) => {
        this.$store.commit('save/finished', this._uid);
        this.dateColors = {
          ...this.dateColors,
          ...response.data.data[this.$route.params.ratePlanType === 'DayRate' ? 'seasonColors' : 'packageSeasonColors'],
        };
        this.loadData(startDate, endDate);
      })
        .catch((error) => {
          this.$store.commit('save/finished', this._uid);
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
      this.$refs.calendar.clearSelection();
    },
    toISODate(date) {
      const result = /^([0-9]{4})([0-9]{2})([0-9]{2})$/i.exec(date);
      return `${result[1]}-${result[2]}-${result[3]}`;
    },
    loadData(startDate = null, endDate = null) {
      if (isNil(startDate)) startDate = this.minDate;
      if (isNil(endDate)) endDate = this.maxDate;

      this.axios.get(this.serviceUrls.seasonDate.list(this, startDate, endDate))
        .then((response) => {
          const seasonMap = keyBy(this.hotelSettings.seasons, 'id');
          const lang = this.hotelSettings.details.primaryLanguage;
          this.seasonDates = {
            ...this.seasonDates,
            ...keyBy(response.data.data.map((it) => {
              const season = seasonMap[this.$route.params.ratePlanType === 'DayRate' ? it.season : it.packageSeason];
              return {
                date: fecha.format(fecha.parse(it.date, 'YYYYMMDD'), 'YYYY-MM-DD'),
                season: isNil(season) || isNil(season.name) || isEmpty(season.name[lang]) ? '-' : season.name[lang],
              };
            }), 'date'),
          };
        });
      this.axios.get(this.serviceUrls.seasonDate.color(this, startDate, endDate))
        .then((response) => {
          this.dateColors = {
            ...this.dateColors,
            ...response.data.data[this.$route.params.ratePlanType === 'DayRate' ? 'seasonColors' : 'packageSeasonColors'],
          };
        });
    },
    toRGB(hexColorCode) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColorCode);
      return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : '';
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/components/Dashboard';
  @import '~styles/import';

  @media (min-width: $br-desktop) {
    .card__inner--sticky {
      position: sticky!important;
      top: 0px!important;
      background-color: #fff!important;
      z-index: 999!important;
    }
  }
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageSeasonCalendar.vue